import { getConfig } from "@jti/fe-common";
import { isEvoError } from "../../utils";
import { Rest } from "../Rest";
export class ReferralApi extends Rest {
    constructor(baseUrl, tenantToken) {
        super(baseUrl);
        this.tenantToken = tenantToken;
        this.name = "ReferralApi";
        this.setCommonHeader("X-DES-AK-TENANT-TOKEN", this.tenantToken);
    }
    static init() {
        const config = getConfig();
        return new ReferralApi(config.REFERRAL_URL, config.REFERRAL_TOKEN);
    }
    getStatus() {
        return this.request("/status", {
            method: "GET",
        })
            .then((response) => response.isActive)
            .catch(() => false);
    }
    getCustomer(uuid, ciam_token) {
        return this.request(`/customer/${uuid}`, {
            headers: { "X-DES-CONSUMER-IAM-TOKEN": ciam_token },
            method: "GET",
        }, true).catch(() => ({
            id: "",
            uuid: "",
            code: "",
            parent_code: "",
            tenant_code: "",
            has_first_purchase: null,
        }));
    }
    verifyCode(code, ciam_token) {
        return this.request(`/verify`, {
            body: JSON.stringify({ code: code }),
            headers: { "X-DES-CONSUMER-IAM-TOKEN": ciam_token },
            method: "POST",
        }, true)
            .then((response) => response.is_valid)
            .catch((err) => {
            if (isEvoError(err))
                throw err;
            return false;
        });
    }
    getReferralStats(customer_uuid, ciam_token) {
        return this.request(`/referrer/${customer_uuid}/stats`, {
            headers: { "X-DES-CONSUMER-IAM-TOKEN": ciam_token },
            method: "GET",
        }, true)
            .then((response) => ({
            earned_points: response.earned_points,
            referees_count: response.referees_count,
            completed_first_order_count: response.completed_first_order_count,
        }))
            .catch(() => ({
            earned_points: 0,
            referees_count: 0,
            completed_first_order_count: 0,
        }));
    }
    updateReferralCode(uuid, referral_code, ciam_token) {
        return this.request("/customer", {
            method: "PUT",
            body: JSON.stringify({
                uuid,
                referral_code,
            }),
            headers: { "X-DES-CONSUMER-IAM-TOKEN": ciam_token },
        }, true).then(() => true);
    }
}
//# sourceMappingURL=ReferralApi.js.map